import 'es6-promise/auto';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// Intersection Observer
import 'intersection-observer';
// Smooth the scroll
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();
// ie trash:
import ie from 'core/utils/ie';
ie.customEventPolyfill();
